import { render, staticRenderFns } from "./newStudent.vue?vue&type=template&id=145e0528&scoped=true"
import script from "./newStudent.vue?vue&type=script&lang=js"
export * from "./newStudent.vue?vue&type=script&lang=js"
import style0 from "./newStudent.vue?vue&type=style&index=0&id=145e0528&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "145e0528",
  null
  
)

export default component.exports